// import Croppie from "@informed-innovations/croppie";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { Button } from "./Button";
import { Modal, ModalBody } from "./Modal";
import { Theme } from "../theme";
let Croppie;
let CroppieVer;
try {
    Croppie = require("@informed-innovations/croppie");
    CroppieVer = require("@informed-innovations/croppie/package.json").version;
} catch (err) {
    Croppie = null;
}

const CroppieContainer = styled.div`
    position: relative;
    margin-top: 1.55em;
    .cr-slider-wrap {
        width: 50%;
    }
    .cr-slider {
        width: 100%;
    }
    .cr-slider-wrap {
        position: absolute;
        top: -80px;
        right: 0px;
        text-align: left;
        &:before {
            content: "Zoom Image & Crop";
            display: block;
            text-align: left;

            font-size: 16px;
            line-height: 1;
            margin-bottom: 0.5em;
        }
    }

    .cr-slider:focus-visible {
        outline: 3px solid ${Theme.colors.cyan};
    }

    .cr-slider::-webkit-slider-runnable-track {
        width: 100%;
        height: 10px;
        background: rgba(0, 0, 0, 0.13);
        border: 0;
        border-radius: 5px;
    }

    .cr-boundary {
        max-width: 100% !important;
        max-height: 100% !important;
    }

    .cr-slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        border: none;
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.1);
        box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.1);
        margin-top: -12px;
    }

    @media only screen and (max-width: 700px) {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        .cr-slider-wrap {
            position: static;
        }
    }
`;

const CropModalBody = styled(ModalBody)`
    padding: 2.5rem;
`;

const ContentFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    gap: 15px;
`;

const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    button {
        min-width: 200px;
    }
`;

export const CropModal = ({
    fileDataUrl,
    onSave,
    onClose,
    onReplaceImage,
    title,
    description,
    buttonText,
    viewport,
    size,
    ...props
}) => {
    const croppie = useRef(null);

    useEffect(() => {
        let dimensions = {
            boundary: { width: 778, height: 511 },
            viewport,
        };
        if (window.innerWidth < 640) {
            dimensions = {
                boundary: {
                    width: window.innerWidth - 40,
                    height: window.innerHeight - 300,
                },
                viewport: {
                    width: viewport.width / 2,
                    height: viewport.height / 2,
                    type: viewport.type,
                },
            };
        }
        if (!croppie.current) {
            if (Croppie) {
                croppie.current = new Croppie(document.getElementById(`upload-logo-crop-image-${title}`), {
                    ...dimensions,
                    onCroppieReady: () => {
                        const viewport = document.getElementsByClassName("cr-viewport")[0];
                        viewport.focus();
                        viewport.setAttribute("aria-label", "Image crop viewport");
                        document.getElementsByClassName("cr-slider")[0].step = 0.01;
                        croppie.current.setZoom(1);
                    },
                });
            } else {
                console.log("Croppie is null");
            }
        }
    }, [title, viewport]);

    useEffect(() => {
        if (!fileDataUrl || !croppie.current) return;

        croppie.current.bind({ url: fileDataUrl });
    }, [fileDataUrl, croppie]);

    const handleSave = () => {
        if (croppie.current && croppie.current.result) {
            croppie.current
                .result({
                    type: "base64",
                    size: {
                        width: size ? size.width : viewport.width,
                        height: size ? size.height : viewport.height,
                    },
                    format: "jpeg",
                    circle: viewport.type === "circle",
                })
                .then((result) => {
                    onSave(result);
                });
        }
    };

    return (
        <Modal maxWidth={"860"} {...props} closeOnBackdropClick={false} showCloseButton={true} onClose={onClose}>
            <CropModalBody>
                <h2>{title ? title : "Crop Image"}</h2>
                <CroppieContainer id={`upload-logo-crop-image-${title}`}></CroppieContainer>
                <ContentFooter>
                    {description && <p>{description}</p>}
                    <ActionsContainer>
                        <Button primary onClick={handleSave}>
                            {buttonText ? buttonText : "Save"}
                        </Button>
                        <Button secondary onClick={onReplaceImage}>
                            Replace Image
                        </Button>
                        <Button secondary onClick={onClose}>
                            Go Back
                        </Button>
                    </ActionsContainer>
                </ContentFooter>
            </CropModalBody>
        </Modal>
    );
};
